import getFilters from 'components/inbox/utils/getFilters';
import {getQuery} from 'utils/getQueryParam';
import {browserHistory} from 'react-router';
import urlParams from 'utils/urlParams';

export function updateInboxFilters(filterChanges, location) {
  const filters = getFilters(getQuery(location));
  const newFilters = filters.merge(filterChanges);
  if (!filters.equals(newFilters)) {
    browserHistory.replace(location.pathname + urlParams(newFilters));
  }
}
